/*
* Automatically generated by 'ng g ng-alain:plugin icon'
* @see https://ng-alain.com/cli/plugin#icon
*/

import {
  AlipayCircleOutline,
  AppstoreOutline,
  BookOutline,
  BranchesOutline,
  CaretRightOutline,
  CustomerServiceOutline,
  DesktopOutline,
  DollarOutline,
  DownloadOutline,
  EditOutline,
  FacebookOutline,
  FileSearchOutline,
  FolderOutline,
  GiftOutline,
  GithubOutline,
  GlobalOutline,
  HeartFill,
  LockOutline,
  MailOutline,
  MenuFoldOutline,
  PhoneOutline,
  PieChartOutline,
  PlusCircleOutline,
  QrcodeOutline,
  QuestionCircleFill,
  QuestionOutline,
  RollbackOutline,
  SafetyOutline,
  ScanOutline,
  SettingOutline,
  ShareAltOutline,
  ShoppingCartOutline,
  StarFill,
  StarOutline,
  SyncOutline,
  TableOutline,
  TaobaoCircleOutline,
  ToolOutline,
  ToTopOutline,
  TrophyOutline,
  UserOutline,
  WechatOutline,
  WeiboCircleOutline,
  WeiboOutline,
  ZhihuOutline,
} from '@ant-design/icons-angular/icons';

export const ICONS_AUTO = [
  AlipayCircleOutline,
  AppstoreOutline,
  BookOutline,
  BranchesOutline,
  CaretRightOutline,
  CustomerServiceOutline,
  DesktopOutline,
  DollarOutline,
  DownloadOutline,
  EditOutline,
  FacebookOutline,
  FileSearchOutline,
  FolderOutline,
  GiftOutline,
  GithubOutline,
  GlobalOutline,
  HeartFill,
  LockOutline,
  MailOutline,
  MenuFoldOutline,
  PhoneOutline,
  PieChartOutline,
  PlusCircleOutline,
  QrcodeOutline,
  QuestionCircleFill,
  QuestionOutline,
  RollbackOutline,
  SafetyOutline,
  ScanOutline,
  SettingOutline,
  ShareAltOutline,
  ShoppingCartOutline,
  StarFill,
  StarOutline,
  SyncOutline,
  TableOutline,
  TaobaoCircleOutline,
  ToTopOutline,
  ToolOutline,
  TrophyOutline,
  UserOutline,
  WechatOutline,
  WeiboCircleOutline,
  WeiboOutline,
  ZhihuOutline
];
